import { api } from "../api";

export default async function destroy(id: number): Promise<boolean> {
  try {
    const { status } = await api.delete(`/interaction/${id}`);

    if (status === 200) {
      return true;
    }

    return false;
  } catch (err) {
    console.log(err);

    return false;
  }
}
